import { animateHeightElement } from "./modules/animation.js";

(function () {
  const navbar = document.querySelector(NAVBAR);
  const sticky = document.querySelector(".js-sticky");
  const menuCollapseElements = navbar ? Array.from(navbar.querySelectorAll(".ux-collapse")) : [];
  const stickyCollapseElements = sticky ? Array.from(sticky.querySelectorAll(".ux-collapse")) : [];
  let collapseElements = Array.from(document.querySelectorAll(".ux-collapse"));

  // Remove menu collapse elements from all collapse elements
  collapseElements = collapseElements.filter(
    (el) => !menuCollapseElements.includes(el) && !stickyCollapseElements.includes(el),
  );

  if (menuCollapseElements) {
    initCollapseAccordion(menuCollapseElements, true);
  }
  if (stickyCollapseElements) {
    initCollapseAccordion(stickyCollapseElements, true);
  }
  initCollapseAccordion(collapseElements, false);

  // Resize event
  window.addEventListener("resize", () => {
    if (menuCollapseElements) {
      initCollapseAccordion(menuCollapseElements, true);
    }
    if (stickyCollapseElements) {
      initCollapseAccordion(stickyCollapseElements, true);
    }
    initCollapseAccordion(collapseElements, false);
  });

  // initialize collapses
  function initCollapseAccordion(collapseElements, close) {
    const isMobile = window.innerWidth < 768;

    removeParentsClassName(collapseElements, "is-active");

    collapseElements.forEach((collapse, index) => {
      const collapsed = collapse.nextElementSibling;
      const readMore = collapsed ? collapsed.querySelector(".js-readMore") : null;

      // open or close collapses according to device and click status
      if (!close && !isMobile) {
        animateHeightElement(collapsed, true, "auto");
        collapse.removeEventListener("click", handleCollapseClick);
      } else {
        animateHeightElement(collapsed, index === 0 && !close);
        collapse.addEventListener("click", handleCollapseClick);
      }

      if (readMore) {
        readMore.addEventListener("click", () => {
          animateHeightElement(collapsed, true, "auto");
        });
      }

      // declare this code after calling the animateHeightElement function
      const isCurrent = collapsed.classList.contains("is-open");
      const collapseParent = collapse.parentElement;

      if (isCurrent) {
        addClassName(collapseParent, "is-active");
      }
    });
  }

  // status of click collapses
  function handleCollapseClick(event) {
    // Prevent default event actions from disturbing or interrupting the execution of associated JavaScript code
    if (event !== null) {
      event.preventDefault();
      event.stopPropagation();

      const collapse = event.currentTarget;
      const collapsed = collapse.nextElementSibling;
      const collapseParent = collapse.parentElement;
      const isCurrent = collapsed.classList.contains("is-open");

      removeParentsClassName(collapseElements, "is-active");
      removeParentsClassName(menuCollapseElements, "is-active");
      removeParentsClassName(stickyCollapseElements, "is-active");

      // If the next element is hidden, it is displayed, otherwise it is hidden.
      if (!isCurrent) {
        /*        collapse.parentElement.classList.add('is-active');*/
        // Add class state on the collapse targeted
        addClassName(collapseParent, "is-active");
        // Display first collapsed content only
        animateHeightElement(collapsed, true);
      } else {
        // Hidden all collapsed content
        animateHeightElement(collapsed, false);
      }

      // If the element is contained in a parent with a specific class, we manage the state of the other elements
      const accordion = collapse.closest(".js-accordion");

      if (accordion) {
        const collapseElementsInAccordion = accordion.querySelectorAll(".ux-collapse");
        collapseElementsInAccordion.forEach((collapseElement) => {
          if (collapseElement !== collapse) {
            const targetInAccordion = collapseElement.nextElementSibling;
            animateHeightElement(targetInAccordion, false);
          }
        });
      }
    }
  }

  // Remove class state for each element
  function removeParentsClassName(elements, className) {
    elements.forEach((el) => {
      el.parentElement.classList.remove(className);
    });
  }

  // Add class state for an element
  function addClassName(el, className) {
    el.classList.add(className);
  }
})();
